import { useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Input } from "reactstrap";
import {
  InstallationPickerOption,
  InstallationPickerRow,
  InstallationPickerSheet,
} from "../installation/InstallationPickerSheet";

const NotificationReasonPicker = ({
  reason,
  onSelectReason,
  reasonList,
  specificReason,
  onSpecificReasonChange,
}) => {
  const { t } = useTranslation();
  const [sheetOpen, setSheetOpen] = useState(false);
  const placeholder = t("mobile_notifications_reason_placeholder");

  const subtitle =
    reason?.value === "other"
      ? specificReason?.trim() || reason.label
      : reason?.label;

  return (
    <>
      <InstallationPickerRow
        icon={FaQuestionCircle}
        title={placeholder}
        subtitle={subtitle}
        placeholder={placeholder}
        onClick={() => setSheetOpen(true)}
      />

      {reason?.value === "other" && (
        <Input
          className="notification-detail-other-reason"
          type="text"
          placeholder={t("Indicate the reason")}
          onChange={(e) => onSpecificReasonChange(e.target.value)}
          value={specificReason}
        />
      )}

      <InstallationPickerSheet
        open={sheetOpen}
        title={t("mobile_notifications_reason_sheet_title")}
        onDismiss={() => setSheetOpen(false)}
      >
        {reasonList.map((item) => (
          <InstallationPickerOption
            key={item.value}
            label={item.label}
            selected={reason?.value === item.value}
            onSelect={() => {
              onSelectReason(item);
              if (item.value !== "other") {
                onSpecificReasonChange("");
              }
              setSheetOpen(false);
            }}
          />
        ))}
      </InstallationPickerSheet>
    </>
  );
};

export default NotificationReasonPicker;
